import { service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class CustomTagListOptionAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;

  override buildURL(
    modelName: string,
    id: string | null,
    snapshot: Parameters<ApplicationAdapter['buildURL']>[2],
    requestType?: string,
  ): string {
    // @ts-expect-error: ApplicationAdapter type declares 3 params but runtime accepts requestType as 4th
    const url = super.buildURL(modelName, id, snapshot, requestType);
    if (
      requestType &&
      ['createRecord', 'updateRecord', 'deleteRecord'].includes(requestType)
    ) {
      const marketId = this.hotelAndMarketService.market?.id;
      if (marketId) {
        return `${url}?market_id=${marketId}`;
      }
    }
    return url;
  }

  urlForCreateRecord(_modelName: string, snapshot: Snapshot): string {
    const definitionId = snapshot.adapterOptions?.['definitionId'] as
      | string
      | undefined;
    if (!definitionId) {
      throw new Error(
        'Missing definitionId in adapterOptions for CustomTagListOption',
      );
    }
    return `${this.host}/${APIGATEWAY}/property-tags/custom/definitions/${definitionId}/options`;
  }

  urlForDeleteRecord(
    id: string,
    _modelName: string,
    snapshot: Snapshot,
  ): string {
    const definitionId = snapshot.adapterOptions?.['definitionId'] as
      | string
      | undefined;
    if (!definitionId) {
      throw new Error(
        'Missing definitionId in adapterOptions for CustomTagListOption',
      );
    }
    return `${this.host}/${APIGATEWAY}/property-tags/custom/definitions/${definitionId}/options/${id}`;
  }

  urlForUpdateRecord(
    id: string,
    _modelName: string,
    snapshot: Snapshot,
  ): string {
    const definitionId = snapshot.adapterOptions?.['definitionId'] as
      | string
      | undefined;
    if (!definitionId) {
      throw new Error(
        'Missing definitionId in adapterOptions for CustomTagListOption',
      );
    }
    return `${this.host}/${APIGATEWAY}/property-tags/custom/definitions/${definitionId}/options/${id}`;
  }
}
